import React, { useRef, useState } from 'react';
import styles from './SchedulerAddTaskAndQueueButtons.module.scss';
import dayjs from 'dayjs';
import clx from 'classnames';
import { modalActions } from '../../../Modals/store';
import { useDispatch, useSelector } from 'react-redux';
import { getCalendarQueue } from '../../store/selectors';
import { CalendarPlus, Coffee, Plus, Users } from 'lucide-react';
import useOutsideClick from '../../../../utils/useOutsideClick';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const SchedulerAddTaskAndQueueButtons = ({
  numberOfActiveDays,
  showAddActions = true,
}) => {
  const dispatch = useDispatch();
  const calendarQueue = useSelector(getCalendarQueue());
  const dropdownRef = useRef(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [searchParams] = useSearchParams();
  const date = searchParams?.get('startDay') || dayjs().format('YYYY-MM-DD');
  const isOlder = dayjs(date).isBefore(dayjs().format('YYYY-MM-DD'));
  const { t } = useTranslation();

  useOutsideClick(dropdownRef, () => {
    if (isDropdownOpen) setIsDropdownOpen(false);
  });

  const closeMenu = () => setIsDropdownOpen(false);

  const openBreakModal = () => {
    closeMenu();
    dispatch(
      modalActions.OPEN_MODAL.SUCCESS({
        type: 'breakModal',
        props: {},
      }),
    );
  };

  const openAddTaskModal = () => {
    closeMenu();
    dispatch(
      modalActions.OPEN_MODAL.SUCCESS({
        type: 'addTaskModal',
        props: {},
      }),
    );
  };

  if (!showAddActions) return null;

  return (
    <div
      className={clx(styles.queue_action_container, {
        // [styles.queue_action_container_hide]: numberOfActiveDays !== 1,
      })}
    >
      {!!calendarQueue?.clientsLength && (
        <button
          type="button"
          className={styles.queue_button}
          disabled={calendarQueue?.clientsLength < 1}
          onClick={() =>
            dispatch(
              modalActions.OPEN_MODAL.SUCCESS({
                type: 'clientsQueueModal',
                props: calendarQueue,
              }),
            )
          }
        >
          <Users size={18} strokeWidth={2.2} />
          <span className={styles.queue_button_value}>
            {t('scheduler.addTaskButtons.queueClients', { count: calendarQueue?.clientsLength })}
          </span>
        </button>
      )}
      <div
        ref={dropdownRef}
        className={clx(styles.create_task_selector, {
          [styles.create_task_selector_open]: isDropdownOpen,
        })}
      >
        {isDropdownOpen && (
          <div className={styles.menu} role="menu">
            <button
              type="button"
              role="menuitem"
              disabled={isOlder}
              onClick={openBreakModal}
              className={clx(styles.menu_item, styles.menu_item_break)}
            >
              <Coffee size={16} strokeWidth={2.2} />
              <span>{t('scheduler.addTaskButtons.takeBreak')}</span>
            </button>
            <button
              type="button"
              role="menuitem"
              onClick={openAddTaskModal}
              className={clx(styles.menu_item, styles.menu_item_booking)}
            >
              <CalendarPlus size={16} strokeWidth={2.2} />
              <span>{t('scheduler.addTaskButtons.newBooking')}</span>
            </button>
          </div>
        )}
        <button
          type="button"
          className={styles.fab}
          aria-expanded={isDropdownOpen}
          aria-label={
            isDropdownOpen
              ? t('scheduler.addTaskButtons.closeMenu')
              : t('scheduler.addTaskButtons.openMenu')
          }
          onClick={() => setIsDropdownOpen((value) => !value)}
        >
          <Plus size={26} strokeWidth={2.4} />
        </button>
      </div>
    </div>
  );
};

export default SchedulerAddTaskAndQueueButtons;
